export const sortFundingStages = (fundingData) => {
    return fundingData.sort((stageA, stageB) => stageA.threshold - stageB.threshold);
}

